function getFormattingDate (timeStamp, tag = true) { // 从timeStamp获得格式化的年月日
  let date = new Date(timeStamp)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let seconds = date.getSeconds()
  return tag ? `${year}年${month}月${day}日` : `${year}年${month}月${day}日 ${hours}时${minutes}分${seconds}秒`
}

function compare (property) {
  return function (a, b) {
    let value1 = a[property]
    let value2 = b[property]
    return value2 - value1
  }
}

export {
  getFormattingDate,
  compare
}



// WEBPACK FOOTER //
// ./src/util/util.js